
import React from 'react'
import ServiceCard from './ServiceCard';
import { ESGIcon, SAP, Risk, Cyber, ChatbotRobot } from '../../config/assets'
import Image from '../atoms/Image';
import { useSelector } from 'react-redux';

const StartServiceCardsContainer = () => {
    const {userDetails} = useSelector((state: any) => state.user);
    const { access } = useSelector((state: any) => state.user);

    return (
        <div  className="text-center flex items-center flex-col mb-3">
            <div className="text-center flex items-center flex-col">
                <Image src={ChatbotRobot} className="w-40" />
                <h6 className="text-xl mt-6 mb-2 text-ey-yellow">Hi{userDetails ? ` ${userDetails?.givenName}` : ''}, Welcome to MS AI Core</h6>
                <p className="text-sm mb-8">How can I help you. Select one from the below, I can support in the following areas</p>
                <div className="motif-row">
                    {/* <div className="motif-col-xs-1">
                        <ServiceCard image={ESGIcon} title="ESG" subtitle="Environmental, Social, and Governance for sustainable investing" disabled />
                    </div>
                    <div className="motif-col-xs-1">
                        <ServiceCard image={SAP} title="SAP" subtitle="Enterprise software for business process management and integration" disabled />
                    </div> */}
                    <div className="motif-col-xs-11">
                        <ServiceCard image={Cyber} title="Cyber" subtitle="Defense against digital threats and safeguarding data integrity" disabled={access?.write === true ? false : true} />
                    </div>
                    {/* <div className="motif-col-xs-1">
                        <ServiceCard image={Risk} title="Risk" subtitle="Evaluation and mitigation of potential negative outcomes" disabled />
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default StartServiceCardsContainer